// extracted by mini-css-extract-plugin
module.exports = {"related-stories-title":"styles-m__related-stories-title__ZH-Wf","related-stories":"styles-m__related-stories__2KMm9","archive-button":"styles-m__archive-button__1pfbW"};